module.exports = __webpack_public_path__ + "static/media/book2.d53e6b89.jpg";